import React from 'react';
import { Icon, Responsive, Select } from 'vendors/semantic-ui';

import { Sort } from 'modules/shared/models';
import { configUI } from 'config/config-ui';
import { Dropdown } from 'semantic-ui-react';
import { ProductSortListProps, ProductSortType, ProductSortTypeValues } from '.';

import styles from './product-sort-list-component.module.css';

const sort: Sort<ProductSortType>[] = [
    {
        text: 'Trier par',
        value: 0,
    },
    {
        text: 'Prix croissant',
        value: 1,
    },
    {
        text: 'Prix décroissant',
        value: 2,
    },
    {
        text: 'Nom',
        value: 3,
    },
];

export const ProductSortList: React.FC<ProductSortListProps> = React.memo(
    ({ selectedValue, handleSortSelection }: ProductSortListProps) => {
        const localSelectedValue = selectedValue || ProductSortTypeValues.UNKNOWN;
        return (
            <>
                <Responsive as={React.Fragment} minWidth={configUI.responsive.tablet.minWidth}>
                    <Select
                        className={`${styles.sortselector} custom-selector`}
                        placeholder="Trier par"
                        value={localSelectedValue}
                        options={sort}
                        onChange={(_e, data) => {
                            if (localSelectedValue !== data.value) {
                                handleSortSelection(data.value as ProductSortType);
                            }
                        }}
                    />
                </Responsive>
                <Responsive as={React.Fragment} maxWidth={configUI.responsive.mobile.maxWidth}>
                    <div className={styles.mobileSelectContainer} role="presentation">
                        <Dropdown
                            className={`${styles.sortMobileSelect} custom-selector`}
                            value={localSelectedValue}
                            options={sort}
                            onChange={(_e, data) => {
                                if (localSelectedValue !== data.value) {
                                    handleSortSelection(data.value as ProductSortType);
                                }
                            }}
                            trigger={<div>Trier par</div>}
                            icon={<Icon size="small" name="sort" />}
                            floating
                            fluid
                            direction="left"
                        />
                    </div>
                </Responsive>
            </>
        );
    },
);
